import React from 'react';
import Notes from './Notes.jsx';

const WeddingNotesIndex = () => {
    return (
        <div>
            <Notes context={"wedding"} />
        </div>
    );
}

export default WeddingNotesIndex;